import api from '@/components/mixins/baseApi';

export default {
  mixins: [api],

  methods: {
    getBanner(_page, _ts) {
      return this.baseAxios({
        method: 'get',
        // завершающий слеш обязателен: без него сервер отвечает 301
        // и каждый баннер стоит двух запросов вместо одного
        url: `${this.$store.getters.apiBasePath}/banner/${_page}/${_ts ? `${_ts}/` : ''}`,
      }, false)
        .then((data) => data.results || null)
        .catch(() => {
          console.error(`Error getting banner ${_page}`);
          return Promise.resolve(null);
        });
    },
  },
};
